import { render, staticRenderFns } from "./ActionTeamBoard.vue?vue&type=template&id=538b6a9c&"
import script from "./ActionTeamBoard.vue?vue&type=script&lang=ts&"
export * from "./ActionTeamBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports